import { Field, ImageField, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from '@gn-audio/jss-components';

export type CaseStudyTileProps = {
  id?: string;
  headline: Field<string>;
  shortDescription: Field<string>;
  longDescription: Field<string>;
  logo: ImageField;
  backgroundColor: Field<string>;
  backgroundImage: ImageField;
  youtubeVideo: Field<string>;
  youkuVideo: Field<string>;
  link: LinkField;
  linkAriaLabel?: Field<string>;
  linkTrackingName?: Field<string>;
  industries: CaseStudiesFilterOption;
  productCategories: CaseStudiesFilterOption;
  software: CaseStudiesFilterOption;
};

export type CaseStudiesSpotFields = {
  caseStudies: CaseStudyTileProps[];
  industryLabel: Field<string>;
  softwareLabel: Field<string>;
  productLabel: Field<string>;
  buttonLabel: Field<string>;
  trackingSpotName?: Field<string>;
};

export type CaseStudiesSpotProps = {
  fields: CaseStudiesSpotFields;
} & ComponentProps;

export type PatternConfig = {
  patterns: string[];
  fallback: string;
  modulus: number;
};

type SinglePatternConfig = {
  pattern: string;
};

export type GridConfigs = {
  xl: PatternConfig;
  lg: PatternConfig;
  md: PatternConfig;
  sm: SinglePatternConfig;
};

export type CaseStudiesFilterOption = {
  id: string;
  value: Field<string>;
  label: Field<string>;
};

export type CaseStudiesFilterType = 'product' | 'industry' | 'software' | 'showall';

export type CaseStudiesFilterProps = {
  caseStudies: CaseStudyTileProps[];
  productLabel: string;
  industryLabel: string;
  softwareLabel: string;
  buttonLabel: string;
  onFilterChange: (filteredStudies: CaseStudyTileProps[]) => void;
};
